import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TagState } from './tag.reducer';

export const selectTagState = createFeatureSelector<TagState>('tag');

export const selectAllTags = createSelector(
  selectTagState,
  (state: TagState) => state.tags
);

export const selectTagsLoading = createSelector(
  selectTagState,
  (state: TagState) => state.loading
);

export const selectTagsError = createSelector(
  selectTagState,
  (state: TagState) => state.error
);

export const selectAttachTagSuccess = createSelector(
  selectTagState,
  (state: TagState) => !state.loading && !state.error  // Success if not loading and no error
);

export const selectAttachTagFailure = createSelector(
  selectTagState,
  (state: TagState) => state.error  // Error if attachTagFailure occurs
);

// Investment-related selectors
export const selectInvestmentLabel = createSelector(
  selectTagState,
  (state: TagState) => state.investmentLabel
);

export const selectInvestmentColor = createSelector(
  selectTagState,
  (state: TagState) => state.investmentColor
);

export const selectInvestmentLoading = createSelector(
  selectTagState,
  (state: TagState) => state.investmentLoading
);

export const selectInvestmentError = createSelector(
  selectTagState,
  (state: TagState) => state.investmentError
);

// Additional selector to check if investment data is available
export const selectHasInvestmentData = createSelector(
  selectTagState,
  (state: TagState) => state.investmentLabel !== null && state.investmentColor !== null
);
